<template>
  <div class="roles-page">
    <hint-page v-if="!confirmPage && showHint" @close="showHint = false">
      <i
        >use the clues to help you identify a less explored perspective. Keep an
        eye on the time. <br><br>We suggest 5 minutes per segment.</i
      >
    </hint-page>

    <hint-page v-show="showSelectedTask" @close="showSelectedTask = false">
      <i>your selected task is&nbsp;</i>
      <b>{{ task }}</b>
    </hint-page>

    <div v-show="roleActiveTab === 'archetypes'">
      <adv-title>select archetype</adv-title>
      <ul class="list">
        <li
          v-for="(archetype, index) in archetypes"
          :key="index"
          :class="{
            inactive:
              selectedArchetype.index > -1 &&
              selectedArchetype.title !== archetype.title,
          }"
          @click="
            $store.dispatch('setArchetype', {
              index: index + 1,
              title: archetype.title,
              text: archetype.text,
            })
          "
        >
          <h1>
            <span class="list-title">> {{ archetype.title }}</span>
            <span class="list-text">{{ archetype.text }}</span>
          </h1>
        </li>
        <li
          :class="{
            inactive:
              selectedArchetype.index > -1 &&
              selectedArchetype.title !== 'other',
          }"
          @click="onOtherArchetype"
        >
          <h1>
            <span class="list-title">> other</span>
            <textarea
              id="other-archetype"
              placeholder="???"
              :disabled="!isController"
              v-model="_archetypeOtherText"
              class="other-input"
            ></textarea>
          </h1>
        </li>
      </ul>
    </div>

    <div v-show="roleActiveTab === 'roles'">
      <adv-title>select role</adv-title>
      <ul class="list">
        <li
          v-for="(role, index) in roles"
          :key="index"
          :class="{
            inactive: selectedRole.index > -1 && selectedRole.title !== role,
          }"
          @click="
            $store.dispatch('setRole', { index: index, title: role, text: '' })
          "
        >
          <h1>
            <b>></b>
            <span class="list-text"> {{ role }}</span>
          </h1>
        </li>
        <li
          :class="{
            inactive: selectedRole.index > -1 && selectedRole.title !== 'other',
          }"
          @click="onOtherRole"
        >
          <h1>
            <b>></b>
            <textarea
              id="other-role"
              placeholder="???"
              :disabled="!isController"
              v-model="_roleOtherText"
              class="other-input"
            ></textarea>
          </h1>
        </li>
      </ul>
    </div>

    <div v-show="roleActiveTab === 'visions'">
      <adv-title>outline your goal</adv-title>
      <textarea
        v-model="vision"
        placeholder="TYPE HERE..."
        :disabled="!isController"
      ></textarea>
    </div>

    <div v-show="roleActiveTab === 'motivations'">
      <adv-title>justify your motives</adv-title>
      <textarea
        v-model="motivation"
        placeholder="TYPE HERE…"
        :disabled="!isController"
      ></textarea>
    </div>

    <page-subnav v-if="!confirmPage">
      <page-subnav-item @click="showSelectedTask = true">task</page-subnav-item>
    </page-subnav>

    <page-subnav-tabs>

      

      <page-subnav-item
        :active="roleActiveTab === 'archetypes'"
        :disabled="!isController"
        @click="$store.dispatch('setRoleTab', 'archetypes')"
        >archetype</page-subnav-item
      >
      <page-subnav-item
        :active="roleActiveTab === 'roles'"
        :disabled="!isController"
        @click="$store.dispatch('setRoleTab', 'roles')"
        >role</page-subnav-item
      >
      <page-subnav-item
        :active="roleActiveTab === 'visions'"
        :disabled="!isController"
        @click="$store.dispatch('setRoleTab', 'visions')"
        >vision</page-subnav-item
      >
      <page-subnav-item
        :active="roleActiveTab === 'motivations'"
        :disabled="!isController"
        @click="$store.dispatch('setRoleTab', 'motivations')"
        >motivation</page-subnav-item
      >
    </page-subnav-tabs>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import HintPage from "./HintPage.vue";
import PageSubnav from "../components/PageSubnav";
import PageSubnavItem from "../components/PageSubnavItem";
import PageSubnavTabs from "../components/PageSubnavTabs";
import AdvTitle from "../components/AdvTitle.vue";

export default {
  name: "roles-page",
  props: {
    confirmPage: Boolean,
  },
  components: {
    HintPage,
    PageSubnav,
    PageSubnavTabs,
    PageSubnavItem,
    AdvTitle,
  },
  data: function () {
    return { showHint: true, showSelectedTask: false };
  },
  computed: {
    ...mapGetters([
      "roles",
      "archetypes",
      "isController",
      "selectedArchetypeText",
      "task",
    ]),
    ...mapState([
      "user",
      "roleActiveTab",
      "selectedRole",
      "pageName",
      "selectedArchetype",
      "visionText",
      "motivationText",
      "archetypeOtherText",
      "roleOtherText",
    ]),
    _archetypeOtherText: {
      set(value) {
        this.$store.commit("SET_ARCHETYPE_OTHER", value);
        this.$store.commit("SET_ARCHETYPE", {
          index: this.archetypes.length,
          title: "other",
          text: value,
        });
      },
      get() {
        return this.archetypeOtherText;
      },
    },
    _roleOtherText: {
      set(value) {
        this.$store.commit("SET_ROLE_OTHER", value);
        this.$store.commit("SET_ROLE", {
          index: this.roles.length,
          title: "other",
          text: value,
        });
      },
      get() {
        return this.roleOtherText;
      },
    },
    vision: {
      set(val) {
        this.$store.commit("SET_VISION", val);
      },
      get() {
        return this.visionText;
      },
    },
    motivation: {
      set(val) {
        this.$store.commit("SET_MOTIVATION", val);
      },
      get() {
        return this.motivationText;
      },
    },
  },

  methods: {
    onOtherArchetype(e) {
      this.$store.commit("SET_ARCHETYPE", {
        index: this.archetypes.length + 1,
        title: "other",
        text: this.archetypeOtherText,
      });
      document.getElementById("other-archetype").focus();
    },
    onOtherRole(value) {
      this.$store.commit("SET_ROLE", {
        index: this.roles.length + 1,
        title: "other",
        text: this.roleOtherText,
      });
      document.getElementById("other-role").focus();
    },
  },
};
</script>



<style lang="less" >
.roles-page .list > li {
  cursor: not-allowed;
}
.controller .roles-page .list > li {
  cursor: pointer;
}

.roles-page {
  width: 768px;
  height: 768px;
  padding: 120px;
  position: relative;
  background-image: url("~@/assets/images/page-blank.png");

  .list {
    margin: 0;
    padding: 0 0 0 0;
    font-size: 30px;

    > li {
      list-style: none;
      display: block;
      position: relative;

      &.inactive {
        opacity: 0.25;
      }

      .other-input {
        // width: 300px;
        background-color: rgba(255, 255, 255, 0);
        border: none;
        outline: none;
        font-style: italic;
        font-weight: 100;
        // color: #f1ece6;
        text-transform: uppercase;

        position: absolute;
        top: 0;
        height: 180px;

        &::placeholder {
          opacity: 1;
        }

        &#other-archetype {
          text-indent: 190px;
        }

        &#other-role {
          text-indent: 24px;
        }
      }
    }
  }

  textarea {
    background-color: rgba(255, 255, 255, 0);
    border: none;
    outline: none;
    display: block;
    width: 530px;
    height: 530px;
    resize: none;
    text-transform: uppercase;
    font-style: italic;
    // color: #f1ece6;

    &::placeholder {
      opacity: 1;
    }
  }

  .confirm-icon {
    position: absolute;
    top: 90px;
    left: 90px;
    // width: 60px;
    // height: 60px;
    // padding: 9px 0 0 9px;
    cursor: pointer;
    z-index: 999;
  }
}
</style>

